import type { LocationDropdownItem } from './updateOrder';

export const PROVINCES: LocationDropdownItem[] = [
  {
    en: 'Alberta',
    twoLetterCode: 'AB',
    fr: 'Alberta',
    es: 'Alberta',
    de: 'Alberta',
    nl: 'Alberta',
    zh: '阿尔伯塔',
  },
  {
    en: 'British Columbia',
    twoLetterCode: 'BC',
    fr: 'Colombie britannique',
    es: 'Columbia Británica',
    de: 'British Columbia',
    nl: 'Brits-Columbia',
    zh: '卑诗省',
  },
  {
    en: 'Manitoba',
    twoLetterCode: 'MB',
    fr: 'Manitoba',
    es: 'Manitoba',
    de: 'Manitoba',
    nl: 'Manitoba',
    zh: '曼尼托巴',
  },
  {
    en: 'New Brunswick',
    twoLetterCode: 'NB',
    fr: 'Nouveau-Brunswick',
    es: 'Nuevo Brunswick',
    de: 'New Brunswick',
    nl: 'New Brunswick',
    zh: '新不伦瑞克',
  },
  {
    en: 'Newfoundland and Labrador',
    twoLetterCode: 'NL',
    fr: 'Terre-Neuve-et-Labrador ',
    es: 'Terranova y Labrador',
    de: 'Newfundland und Labrador',
    nl: 'Newfoundland en Labrador',
    zh: '纽芬兰与拉布拉多',
  },
  {
    en: 'Northwest Territories',
    twoLetterCode: 'NT',
    fr: 'Territoires du Nord-Ouest',
    es: 'Territorios del Noroeste',
    de: 'Nordwest-Territorien',
    nl: 'Northwest Territories',
    zh: '西北领地',
  },
  {
    en: 'Nova Scotia',
    twoLetterCode: 'NS',
    fr: 'Nouvelle-Écosse',
    es: 'Nueva Escocia',
    de: 'Nova Scotia',
    nl: 'Nova Scotia',
    zh: '新斯科舍',
  },
  {
    en: 'Nunavut',
    twoLetterCode: 'NU',
    fr: 'Nunavut',
    es: 'Nunavut',
    de: 'Nunavut',
    nl: 'Nunavut',
    zh: '努勒维特',
  },
  {
    en: 'Ontario',
    twoLetterCode: 'ON',
    fr: 'Ontario',
    es: 'Ontario',
    de: 'Ontario',
    nl: 'Ontario',
    zh: '安大略',
  },
  {
    en: 'Prince Edward Island',
    twoLetterCode: 'PE',
    fr: 'Île-du-Prince-Édouard',
    es: 'Isla del Príncipe Eduardo',
    de: 'Prince Edward Island',
    nl: 'Prins Edwardeiland',
    zh: '爱德华王子岛',
  },
  {
    en: 'Quebec',
    twoLetterCode: 'QC',
    fr: 'Québec',
    es: 'Quebec',
    de: 'Quebec',
    nl: 'Quebec',
    zh: '魁北克',
  },
  {
    en: 'Saskatchewan',
    twoLetterCode: 'SK',
    fr: 'Saskatchewan',
    es: 'Saskatchewan',
    de: 'Saskatchewan',
    nl: 'Saskatchewan',
    zh: '萨斯喀彻温',
  },
  {
    en: 'Yukon Territories',
    twoLetterCode: 'YT',
    fr: 'Yukon',
    es: 'Yukón',
    de: 'Yukon',
    nl: 'Yukon',
    zh: '育空',
  },
];
